<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-badge color="red" right overlap v-model="showBadge">
          <span slot="badge">{{ count }}</span>
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, i) in notifications"
        :key="i"
        @click="navigateTo(item.link)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.msg }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="notifications.length == 0">
        <v-list-item-title class="pl-1 pr-1" style="font-size: 80%;">
          <em>{{ $t('notifications.you_have_no_notifications') }}</em>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import navigateMixin from '../../mixins/navigate'

export default {
  mixins: [navigateMixin],

  computed: {
    ...mapGetters({
      unreadNetworkingMessagesIds: 'unreadNetworkingMessagesIds',
      unreadMessagesCount: 'unreadMessagesCount',
    }),

    count() {
      return this.unreadNetworkingMessagesIds.length + this.unreadMessagesCount
    },

    showBadge() {
      return this.count > 0
    },

    notifications() {
      let ntfs = []

      this.checkModule(
        ntfs,
        'networking',
        this.unreadNetworkingMessagesIds.length,
        'notifications.you_have_x_unread_network_messages'
      )
      this.checkModule(
        ntfs,
        'messages',
        this.unreadMessagesCount,
        'notifications.you_have_x_unread_messages'
      )

      return ntfs
    },
  },

  methods: {
    checkModule(notifications, module, count, translateString) {
      let route = this.findRoute(module)
      if (route != null && count > 0) {
        notifications.push({
          title: route.name,
          msg: this.$tc(translateString, count, { n: count }),
          link: {
            slug: route.slug,
          },
        })
      }
    },
  },
}
</script>
